import React, { useState } from "react";
import PropTypes from "prop-types";
import CITYIMAGE from "../assets/City.png";

const AllServicesTiles = ({ services, t }) => {
    AllServicesTiles.propTypes = {
        services: PropTypes.array.isRequired,
        t: PropTypes.func.isRequired,
    };

    const [isServiceOpen, setIsServiceOpen] = useState(false);

    const handleServiceClick = () => {
        setIsServiceOpen(true);
    };

    const handleCloseServicePopup = () => {
        setIsServiceOpen(false);
    };

    return (
        <div className="px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-0 mb-10">
            <div className="relative place-items-center bg-white mb-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 justify-start">
                {Array.isArray(services) &&
                    services.map((service) => {
                        const { id, name, image, url } = service;

                        return (
                            <div
                                key={id}
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-full bg-white shadow-[0_3px_10px_rgb(0,0,0,0.2)] rounded-2xl overflow-hidden transition-transform duration-300 hover:scale-105 cursor-pointer flex flex-col h-full"
                            >
                                <div className="relative h-80 rounded-2xl"
                                    onClick={handleServiceClick}
                                >
                                    <img
                                        alt={name}
                                        className="object-cover object-center h-full w-full"
                                        src={image}
                                        loading="lazy"
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = CITYIMAGE;
                                        }}
                                    />
                                    <div
                                        className="absolute inset-0 flex flex-col justify-end text-white"
                                        style={{
                                            background:
                                                "linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)",
                                        }}
                                    >
                                        <h1
                                            className="text-xl pb-5 md:text-3xl font-sans font-bold mb-0 ml-4"
                                            style={{
                                                fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif",
                                            }}
                                        >
                                            {name}
                                        </h1>
                                    </div>
                                </div>

                                {isServiceOpen && (
                                    <div className="fixed top-0 left-0 w-full h-full bg-black/20 backdrop-blur-sm flex items-center justify-center z-[99999]">
                                        <div className="bg-white p-4 rounded-lg shadow-lg w-3/4 h-3/4 flex flex-col">
                                            <button
                                                className="bg-white rounded-md p-2 inline-flex items-center justify-end text-red-600"
                                                onClick={handleCloseServicePopup}
                                            >
                                                <span className="sr-only">Close menu</span>
                                                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                                </svg>
                                            </button>
                                            <iframe
                                                loading="lazy"
                                                src="https://static.hamburg.de/kartenclient/prod/"
                                                allow="geolocation"
                                                className="w-full h-full"
                                                title="Service Popup"
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default AllServicesTiles;